import OinqHappy from './assets/Oinq_keep.svg';
import OinqDuo from './assets/Oinq_share.svg';
import OinqGive from './assets/Oinq_give.svg';

const REFERRAL_INVITE_TYPES = [
  {
    inviteType: 'qmee_none',
    title: 'Keep %1s;',
    titleValue: (currencySymbol: string) => `${currencySymbol}1`,
    description: "You'll keep 100% of the reward - go on, you deserve it!",
    image: OinqHappy,
  },
  {
    inviteType: 'qmee_equal_split',
    title: 'Keep %1s;, Give %1s;',
    titleValue: (currencySymbol: string) => `${currencySymbol}0.50`,
    description: 'Share the reward equally with your friend - %1s; for each of you, yay!',
    descriptionValue: (currencySymbol: string) => `${currencySymbol}0.50`,
    image: OinqDuo,
  },
  {
    inviteType: 'qmee_all',
    title: 'Give %1s;',
    titleValue: (currencySymbol: string) => `${currencySymbol}1`,
    description: "You'll give 100% of the reward to your friend - you're generous like that",
    image: OinqGive,
  },
];

export default REFERRAL_INVITE_TYPES;
